import React from 'react';
import './WarrantyContent.css';

const WarrantyContent = () => {
  return (
    <div className="warranty-content">
      {/* الضمان يشمل */}
      <section className="warranty-section-card warranty-includes">
        <div className="section-header">
          <div className="section-icon">✓</div>
          <h2 className="section-title">الضمان يشمل</h2>
        </div>
        <div className="section-content">
          <div className="warranty-item">
            <div className="item-bullet"></div>
            <p>يشمل الجهاز ضمان 24 شهر يبدأ من تاريخ الشراء</p>
          </div>
          <div className="warranty-item">
            <div className="item-bullet"></div>
            <p>يغطي الضمان العيوب في الجهاز الناتجة عن أخطاء في الصنع</p>
          </div>
          <div className="warranty-item">
            <div className="item-bullet"></div>
            <p>ينطبق الضمان على الاستخدام المنزلي للجهاز</p>
          </div>
        </div>
      </section>

      {/* تعليمات الضمان */}
      <section className="warranty-section-card warranty-instructions">
        <div className="section-header">
          <div className="section-icon">ℹ</div>
          <h2 className="section-title">تعليمات الضمان</h2>
        </div>
        <div className="section-content">
          <div className="warranty-item">
            <div className="item-bullet"></div>
            <p>الرجاء الاحتفاظ بفاتورة شراء المنتج و إظهارها عند مراجعة الأطراف المعنية</p>
          </div>
          <div className="warranty-item highlight">
            <div className="item-bullet highlight"></div>
            <p>
              <strong>للاستفسارات و الشكاوى الرجاء التواصل مع الرقم المجاني:</strong>
              <a href="tel:1800400444" className="phone-link" dir="ltr">1800 400 444</a>
            </p>
          </div>
        </div>
      </section>

      {/* لا يشمل الضمان */}
      <section className="warranty-section-card warranty-excludes">
        <div className="section-header">
          <div className="section-icon">✗</div>
          <h2 className="section-title">لا يشمل الضمان</h2>
        </div>
        
        <div className="section-content">
          <h3 className="subsection-title brand-title">Braun</h3>
          <div className="warranty-item">
            <div className="item-bullet exclude"></div>
            <p>خارج فترة الضمان</p>
          </div>
          <div className="warranty-item">
            <div className="item-bullet exclude"></div>
            <p>الأضرار الناتجة عن الاستخدام الغير صحيح أو التشغيل على فولتيه غير مناسبة</p>
          </div>
          <div className="warranty-item">
            <div className="item-bullet exclude"></div>
            <p>كسر الشفرات أو الجرار الزجاجي</p>
          </div>
          <div className="warranty-item">
            <div className="item-bullet exclude"></div>
            <p>الاستهلاك الطبيعي على الأجزاء المتحركة</p>
          </div>
          <div className="warranty-item">
            <div className="item-bullet exclude"></div>
            <p>إذا تم إصلاح الجهاز من قبل أشخاص غير معتمدين أو باستخدام قطع غير أصلية</p>
          </div>
          <div className="warranty-item">
            <div className="item-bullet exclude"></div>
            <p>الجهاز غير مخصص للأطفال دون إشراف</p>
          </div>
          <div className="warranty-item">
            <div className="item-bullet exclude"></div>
            <p>إذا كان الجهاز يعمل بواسطة كابل تمديد أو مأخذ كهربائي محمول يجب وضعه بحيث لا يتعرض للرذاذ أو الرطوبة</p>
          </div>
        </div>

        <div className="section-content">
          <h3 className="subsection-title brand-title">Oral - B</h3>
          <div className="warranty-item">
            <div className="item-bullet exclude"></div>
            <p>سوء الاستخدام</p>
          </div>
          <div className="warranty-item">
            <div className="item-bullet exclude"></div>
            <p>التآكل الطبيعي خاصة رؤوس الفرشاة</p>
          </div>
          <div className="warranty-item">
            <div className="item-bullet exclude"></div>
            <p>الأعطال التي لا تؤثر بشكل واضح على أداء الجهاز</p>
          </div>
          <div className="warranty-item">
            <div className="item-bullet exclude"></div>
            <p>إذا تم إصلاح الجهاز من قبل أشخاص غير معتمدين أو باستخدام قطع غير أصلية</p>
          </div>
          
          <div className="special-note">
            <h4 className="note-title">لطراز 5 Series iO فقط:</h4>
            <div className="warranty-item note-item">
              <div className="item-bullet exclude"></div>
              <p>الأجهزة مزودة بواجهة بلوتوث ذكية معتمدة. أي مشاكل في الاتصال بالهاتف غير مشمولة بالضمان إلا إذا كانت نتيجة عيب في واجهة البلوتوث نفسها</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default WarrantyContent;

